
import { useCart } from '../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

export default function MiniCart() {
  const { items, showMiniCart, setShowMiniCart, totalPrice } = useCart();
  const navigate = useNavigate();

  if (!showMiniCart || items.length === 0) return null;

  const latestItem = items[items.length - 1];

  const handleViewCart = () => {
    setShowMiniCart(false);
    navigate('/cart');
  };

  const handleContinueShopping = () => {
    setShowMiniCart(false);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      <div className="absolute inset-0 bg-black/50" onClick={() => setShowMiniCart(false)}></div>
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#FEFEFE] shadow-xl transform transition-transform">
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-6 border-b border-[#E8ECF2]">
            <h2 className="text-lg font-semibold text-[#1E2328]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Added to Cart
            </h2>
            <button
              onClick={() => setShowMiniCart(false)}
              className="w-8 h-8 flex items-center justify-center text-[#6B7380] hover:text-[#F3B11A] transition-colors"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
          
          <div className="flex-1 p-6">
            <div className="flex items-center space-x-4 mb-6">
              <img
                src={latestItem.image}
                alt={latestItem.name}
                className="w-16 h-16 object-cover rounded-lg"
              />
              <div className="flex-1">
                <h3 className="font-medium text-[#1E2328] mb-1">{latestItem.name}</h3>
                <p className="text-sm text-[#6B7380]">
                  {latestItem.color && `${latestItem.color} • `}
                  {latestItem.size && `${latestItem.size} • `}
                  Qty: {latestItem.quantity}
                </p>
                <p className="text-lg font-bold text-[#1E2328]">£{(latestItem.price * latestItem.quantity).toFixed(2)}</p>
              </div>
            </div>

            <div className="bg-[#F8F9FA] rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between text-sm mb-2">
                <span className="text-[#6B7380]">Items in cart:</span>
                <span className="text-[#1E2328] font-medium">{items.reduce((sum, item) => sum + item.quantity, 0)}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-[#1E2328] font-semibold">Cart total:</span>
                <span className="text-[#1E2328] font-bold text-lg">£{totalPrice.toFixed(2)}</span>
              </div>
            </div>
            
            <div className="space-y-3">
              <button
                onClick={handleViewCart}
                className="w-full py-3 bg-[#F3B11A] text-[#01164F] rounded-lg font-medium hover:bg-[#E5A010] transition-colors whitespace-nowrap"
              >
                View Cart ({items.length})
              </button>
              <button
                onClick={handleContinueShopping}
                className="w-full py-3 border border-[#F3B11A] text-[#F3B11A] rounded-lg font-medium hover:bg-[#F3B11A] hover:text-[#01164F] transition-colors whitespace-nowrap"
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
